<script setup>
  import { onMounted, ref } from "vue";
  import LoaderCircle from "@/components/LoaderCircle.vue";

  const showLoader = ref(false);

  onMounted(() => {
    setTimeout(() => {
      showLoader.value = true;
    }, 300);
  });
</script>

<template>
  <div class="jwx-data-container__loader">
    <LoaderCircle />
  </div>
</template>